module.exports = __webpack_public_path__ + "img/logo.d7c89e0c.svg";